define(function(require) {
	// general
	const CN = require('civicsUtils/constants');
	const InstrumentUtils = require('civicsUtils/instrument_utilities');
	const Marionette = require('backbone.marionette');
	const Utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');

	// models
	const InspectionModel = require('civicsModels/inspection_model');
	const RequestInspectionModel = require('civicsModels/request_inspection_model');
	// templates
	const tpl = require('civicsViews/inspection_request/templates/t_itv_inspection_cancel_request.hbs');
	//utilities
	const AvailableFeatures = require('civicsUtils/available_features');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.config = options.config;
			this.model = options.model;
			this.modalRegion = options.modalRegion;
			this.parentView = options.parentView;
		},
		template: tpl,
		className: 'inspection-detail-modal',
		events: {
			'click @ui.btnBack': 'backClicked',
			'click @ui.btnCancelRequest': 'cancelRequestClicked',
			'click @ui.btnClose': 'backClicked'
		},
		ui:{
			btnClose: '.bbm-btn-close',
			btnBack:'.btn-back-confirmation',
			btnCancelRequest:'.btn-cancel-confirmation'
		},
		backClicked:function(){
			if(__DEV__) console.log('itv cancel request -- backClicked');

			this.triggerMethod('back:clicked');

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		enableButtons: function(enable){
			this.ui.btnBack.prop('disabled', !enable);
			this.ui.btnCancelRequest.prop('disabled', !enable);
		},
		cancelRequestClicked:function(){
			if(__DEV__) console.log('itv cancel request -- cancelRequestClicked');
			this.enableButtons(false);
			ViewManager.loading(true);
			var self = this;
			//the fields will be cleared through the service
			if(AvailableFeatures.SpecialInstructions()){
				var inspectionId = this.model.get('id');
				this.requestInspectionModel = new RequestInspectionModel();
				this.requestInspectionModel.formatUrlRoot(this.config.fromServer.instrumentType);
				this.requestInspectionModel.set({
						id: inspectionId
					});

				this.requestInspectionModel.destroy({
					success: function(model, response, options) {
						ViewManager.broadcast(self,'saved');
						ViewManager.loading(false);
						if(__DEV__) console.log('itv cancel request -- cancelRequest done function after save model');
						// 2016-02-11 PL:  Note, don't need to write to inspection log for customer view

						if (self.parentView){
							self.parentView.requestCancelled(response.data);
						} else {
							self.requestInspectionModel.set(response.data);
							self.triggerMethod('cancelInspectionRequestConfirmation:clicked', self.requestInspectionModel);
						}

						if(self.modalRegion) {
							self.modalRegion.hideModal();
						}
						else {
							self.destroy();
						}
						self.render();
					}.bind(this),
					error: function(model, response, options){
						ViewManager.errorToWindow(response, this);
						ViewManager.loading(false);
						self.enableButtons(true);
					}
				});
			} else {
			// 2016-02-11 PL:  Clear the assignedToProvider, callDateTime, and scheduledDateTime (per Amy email)
			this.model.set({
				'assignedToProvider':{id:1},
				'callDateTime':CN.DATE_TIME_MIN_VAL,
				'scheduledDateTime':CN.DATE_TIME_MIN_VAL
				});
			this.model.save(null, {
				error: function(model, response, options){
					ViewManager.errorToWindow(response, this);
					ViewManager.loading(false);
					self.enableButtons(true);
				}
			})
			.done(function(response, status, xhrResponse) {
				ViewManager.broadcast(self,'saved');
				ViewManager.loading(false);
				if(__DEV__) console.log('itv cancel request -- cancelRequest done function after save model');

				// 2016-02-11 PL:  Note, don't need to write to inspection log for customer view
				if (self.parentView){
					self.parentView.requestCancelled(response.data);
				} else {
					self.triggerMethod('cancelInspectionRequestConfirmation:clicked');
				}

				if(self.modalRegion) {
					self.modalRegion.hideModal();
				}
				else {
					self.destroy();
				}
			})
			.fail(function(response, status, xhrResponse){
			   ViewManager.errorToWindow(response);
			   ViewManager.loading(false);
			   self.enableButtons(true);
			});
		}
		},
		templateHelpers: function(){
			var self = this;
			return {
				modelId: self.model.get('id'),
				currentDate: function() {
					return Handlebars.helpers['global:formatDate'](Utils.dateTimeStringFromDate(new Date())); //isoFixed
				},
				displayDate: function() {
					//
					// Show the scheduledDateTime if it exists, otherwise show the callDateTime.
					var scheduledDateTime = self.model.get('scheduledDateTime');
					var callDateTime = self.model.get('callDateTime');
					if (typeof scheduledDateTime != 'undefined' && Utils.dateExists(scheduledDateTime)) {
						return Handlebars.helpers['global:formatDate'](scheduledDateTime);
					}
					if (typeof callDateTime != 'undefined' && Utils.dateExists(callDateTime)) {
						return Handlebars.helpers['global:formatDate'](callDateTime);
					}
					if(typeof callDateTime.indexOf(CN.DATE_TIME_MIN_VAL)){
						return '';
					}
					// None of the above
					return i18n.t('CIVICS.INSPECTION_REQUEST.ERROR_GETTING_DATE');
				},
				showRequestDate: this.config.globalConfig.usesInspectionRequestDate != 'Hide',
			};
		}
	});
});
